import type { TNamespacedTrans } from '../definitions'

/**
 * Factory függvény, ami egy namespacelt kulcsösszerakó függvényt csinál.
 * @param ns - A namespace, amihez konkatolni akarjuk a többi kulcsrészletet.
 */
export default function createNamespace (ns: string): TNamespacedTrans {
  return function namespacedTrans (...keys: (string | number)[]): string {
    const fullKey = [ ns, ...keys ].join('.')

    return fullKey
  }
}
